export default "__VITE_ASSET__9aYLDs2c__";